function fn_part_product_info() {
    var $part = $(".part_product_info");
    nl_fn_switch_content($part.find("[data-switch]"),0);
}